//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as apis from "@/api";
import { conversion } from "@/tool";
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      RebateRate: 0,
      counterTime: {
        timeId: 0, //计时器id
        totalSeconds: 0,
        day: "00",
        hour: "00",
        min: "00",
        sec: "00",
      },
    };
  },
  computed: {
    ...mapState(["user"]),
    list() {
      let arr = [];
      if (this.activetyList && this.activetyList.length > 0) {
        arr = this.activetyList;
      }
      return arr;
    },
  },
  filters: {
    conversion,
  },
  watch: {},
  created() {
    this.getRebateDetail();
    this.sumTime(this.counterTime.totalSeconds);

    this.counterTime.timeId = setInterval(() => {
      let time = --this.counterTime.totalSeconds;

      if (time <= 0) {
        //clearInterval(this.counterTime.timeId);
        this.$store.commit("setInfo");
        this.getRebateDetail();
      } else {
        this.sumTime(time);
      }
    }, 1000);
  },
  mounted() {},
  methods: {
    loginbtnClick() {
      this.$store.commit("setloginModal", true);
    },
    sumTime(time) {
      const day = Math.floor(time / (60 * 60 * 24));
      const hour = Math.floor((time / (60 * 60)) % 24);
      const min = Math.floor((time / 60) % 60);
      const sec = Math.floor(time % 60);

      this.counterTime.day = `0${day}`.slice(-2);
      this.counterTime.hour = `0${hour}`.slice(-2);
      this.counterTime.min = `0${min}`.slice(-2);
      this.counterTime.sec = `0${sec}`.slice(-2);

      //console.log(this.counterTime);
    },
    getRebateDetail() {
      apis.RebateDetail().then((res) => {
        this.counterTime.totalSeconds = res.data.data.totalSeconds;
        this.RebateRate = res.data.data.rate * 100;
      });
      console.log(this.counterTime.totalSeconds);
    },
  },
  beforeDestroy() {
    clearInterval(this.counterTime.timeId);
  },
};
